import { initializeApp } from 'firebase/app'
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Services
export const db = getFirestore(app)
export const auth = getAuth(app)

// Initialize Analytics (lazy load to avoid ad blocker issues)
export const initAnalytics = async () => {
  try {
    const { getAnalytics, isSupported } = await import('firebase/analytics')
    if (await isSupported()) {
      return getAnalytics(app)
    }
  } catch (e) {
    console.warn('Analytics blocked or unavailable')
  }
  return null
}

// Firestore helper functions
export const submitInquiry = async (data: {
  name: string
  email: string
  phone?: string
  businessName?: string
  services: string[]
  message: string
}) => {
  const inquiriesRef = collection(db, 'inquiries')
  return addDoc(inquiriesRef, {
    ...data,
    status: 'new',
    createdAt: serverTimestamp(),
  })
}

export const subscribeNewsletter = async (email: string) => {
  const newsletterRef = collection(db, 'newsletter')
  return addDoc(newsletterRef, {
    email,
    subscribedAt: serverTimestamp(),
  })
}

export default app
